<template>
    <DialogComponent
        cancelLabel="not now"
        @cancel="closeModal"
        @continue="setModal(Modals.idCardVerification.code)"
    >
        <Intro :daysRemaining="daysRemaining"/>
    </DialogComponent>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Modals from '@store/modules/ui/shared/modal/modals';
    import { idCardRemainingDays } from '@countryModels/user/UserDataService';
    import Intro from '@modules/userProfile/idCardVerification/components/Intro';
    import DialogComponent from '../../components/DialogComponent';

    export default {
        name: 'IdCardVerificationIntroModal',
        created() {
            this.Modals = Modals;
            this.daysRemaining = idCardRemainingDays(this.user);
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
            ]),
        },
        methods: {
            ...mapActions('ui/modal', [
                'setModal',
                'closeModal',
            ]),
        },
        components: {
            Intro,
            DialogComponent,
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modals/modals/userProfile/idCardVerification/IdCardVerificationIntroModal.vue